<template>
    <section class="hero-wrap section pt-5">
        <div class="hero-bg" style="background-size: cover;background: url('/img/Curve Line.svg') no-repeat;"></div>
        <div class="hero-content">
            <div class="container">
                <div class="card card-body mb-3">
                    <div class="d-flex align-items-center">
                        <div class="profile-thumb">
                            <img class="rounded-circle border p-2" style="height: 100px"
                                 :src="'https://robohash.org/' + model.name + ' ' + model.last_name" alt="">
                        </div>
                        <div class="flex-grow-1 px-4 pt-2">
                            <p class="text-3 font-weight-500 mb-3">
                                {{ model.name }} {{ model.last_name }}
                                <span class="badge badge-success">{{ model.email }}</span>
                            </p>
                            <ul class="nav nav-pills mb-4">
                                <li class="nav-item">
                                    <router-link class="nav-link rounded-lg" active-class="active" exact=""
                                                 to="/profile">Account
                                    </router-link>
                                </li>
                                <li class="nav-item">
                                    <router-link class="nav-link rounded-lg" active-class="active" exact=""
                                                 to="/profile/password">
                                        Password
                                    </router-link>
                                </li>
                                <li class="nav-item">
                                    <router-link class="nav-link rounded-lg" active-class="active" exact=""
                                                 to="/transactions">
                                        Transactions
                                    </router-link>
                                </li>
                                <li class="nav-item">
                                    <router-link class="nav-link rounded-lg" active-class="active" exact=""
                                                 to="/transactions/batch">Batches
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <keep-alive>
                    <transition name="slide-in-left">
                        <router-view></router-view>
                    </transition>
                </keep-alive>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "profile",
    methods: {
        init() {
            this.loading = true;
            window.axios.get(`${window.location.origin}/admin/auth`).then((response) => {
                this.model = response.data.body.model;
            }).finally(() => {
                this.loading = false;
            });
        },
    },
    mounted() {
        this.init();
    },
    data() {
        return {
            model: {}
        };
    }
}
</script>

<style scoped>
.nav-link {
    color: #252C65 !important;
    background-color: #eeeeee !important;
    margin-right: 0.5rem;
}

.nav-link.active {
    color: white !important;
    background-color: #252C65 !important;
}
</style>

